import { getAssetType, getNonRequisitionAssetType } from "./AssetTypeAction";

const dispatchGetAssetType = (dispatch: Function) => () => {
    dispatch(getAssetType());
};

const dispatchGetNonRequisitionAssetType = (dispatch: Function) => () => {
    dispatch(getNonRequisitionAssetType());
};

const AssetTypeDispatch = {
    dispatchGetAssetType,
    dispatchGetNonRequisitionAssetType
};

export default AssetTypeDispatch